import { render, staticRenderFns } from "./detail-page.vue?vue&type=template&id=0fbcaf08"
import script from "./detail-page.vue?vue&type=script&lang=js"
export * from "./detail-page.vue?vue&type=script&lang=js"
import style0 from "./detail-page.vue?vue&type=style&index=0&id=0fbcaf08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports